<template>
	<div>
		<img v-if="pictureBlob" :src="pictureBlob" class="profile-avatar" />
	</div>
</template>

<script lang="ts">
import { AuthService } from '@/contracts/AuthService';
import { ref, inject, onMounted } from 'vue';

export default {
	name: 'ProfilePicture',
	props: {
	},
	setup() {
		const auth = inject('auth') as AuthService;
		const pictureBlob = ref<string | null>(null);

		onMounted(async () => {
			await auth.getProfilePicture().then((blob: string | null) => {
				pictureBlob.value = blob;
			});
		});

		return {
			pictureBlob
		}
	}
}
</script>

<style scoped>
.profile-avatar {
	width: 2rem;
	height: 2rem;
	border-radius: 50%;
	object-fit: cover;
}
</style>
